import type { PlatformRole } from '../../../types/platform-role';
import { APP_ROUTES } from '../../app-routes';

export const isSuperAdminPath = (pathname: string): boolean =>
  pathname === APP_ROUTES.SUPER_ADMIN.DASHBOARD ||
  pathname.startsWith(`${APP_ROUTES.SUPER_ADMIN.DASHBOARD}/`);

export type SuperAdminAccess = 'loading' | 'notFound' | 'allowed';

type SuperAdminAccessContext = {
  hasSession: boolean;
  isAuthLoading: boolean;
  isUserLoading: boolean;
  hasUserError: boolean;
  canAccessPlatformAdmin: boolean;
  platformRole?: PlatformRole | null;
  pathname?: string;
};

export const canAccessAdminPath = (
  platformRole: PlatformRole | null | undefined,
  pathname: string
): boolean => {
  if (platformRole === 'super_admin') return isSuperAdminPath(pathname);
  if (platformRole !== 'operations_admin') return false;
  if (pathname === APP_ROUTES.SUPER_ADMIN.DASHBOARD) return true;
  return [
    APP_ROUTES.SUPER_ADMIN.PARTNERS,
    APP_ROUTES.SUPER_ADMIN.USERS,
    APP_ROUTES.SUPER_ADMIN.OPERATIONS,
  ].some((path) => pathname === path || pathname.startsWith(`${path}/`));
};

export const resolveSuperAdminAccess = ({
  hasSession,
  isAuthLoading,
  isUserLoading,
  hasUserError,
  canAccessPlatformAdmin,
  platformRole,
  pathname = APP_ROUTES.SUPER_ADMIN.DASHBOARD,
}: SuperAdminAccessContext): SuperAdminAccess => {
  if (isAuthLoading || (hasSession && isUserLoading)) return 'loading';
  if (
    !hasSession ||
    hasUserError ||
    !canAccessPlatformAdmin ||
    !canAccessAdminPath(platformRole, pathname)
  )
    return 'notFound';
  return 'allowed';
};
